import  { Component } from '@angular/core';
import { Events } from 'ionic-angular';

import { NavController, AlertController, LoadingController, Loading } from 'ionic-angular';
import { AuthService } from './../../providers/auth-service';

//import { DashboardPage } from '../dashboard/dashboard';

import { SharedComponent } from '../../shared/shared';
import { RegisterPage } from './register';
import { ForgotComponent } from './forgot';
import { ContactUsComponent } from './contact-us';

import { CommonService } from './../../services/common.service';
//import { PricingPage } from '../pricing/pricing';
import { TermsPolicyPage } from './terms-policy';
import { CancellationRefundPage } from './cancellation';
/*import { WalkthroughComponent } from 'angular-walkthrough';*/
//import { ActivatedRoute } from '@angular/router';

@Component({
	templateUrl:'login.html'
})

export class LoginComponent  {
	
	

	/*loginBtnClick(event){
		alert();
		this.navCtl.push(HelloIonicPage);

	}*/

	$onInit = () => { 
		
		//  this.route.queryParams.subscribe(params => {
		//   if (params) {
		//     console.log("fffffffffff", params)
		//   }
		// });
	};

	ionViewDidLoad() {
		if(window.location.href.indexOf('register=1')>-1){
			this.nav.push(RegisterPage);
		}  

     // this.ratingFactor=[{factorId: "1", categoryId: "1", factorName: "Test", isActive:true},{factorId: "2", categoryId: "1", factorName: "Quantity", isActive:true}    ,
     // {factorId: "3", categoryId: "1", factorName: "Service", isActive:true}     ,
     // {factorId: "4", categoryId: "1", factorName: "Price", isActive:true}]
     // ;
   }

	isActive=true;
	loading: Loading;
	registerCredentials = { email: '', password: '' };
	// allLanguage=[{"language":"English","languageId":"en"},
	// 			{"language":"Română","languageId":"ro"},
	// 			{"language":"हिंदी",languageId:"hi"},
	// 			{"language":"Español",languageId:"es"},
	// 			{"language":"العربية",languageId:"ar"}								
	// 			]
	// selectedItem="en";			

	constructor(private nav: NavController, private auth: AuthService, private alertCtrl: AlertController, private loadingCtrl: LoadingController,public events: Events,public sharedClass:SharedComponent, private commonService:CommonService) { 
		commonService.backButtonAction(nav);
	}

	public createAccount() {
		this.nav.push(RegisterPage);
	}

	public forgotPassword() {
		this.nav.push(ForgotComponent);
	}

	public goToPage(page,number) {		
		if(number=="1"){
			this.nav.push(TermsPolicyPage);
		}else if(number=="2"){
			this.nav.push(ContactUsComponent);
		}else if(number=="3"){
			this.nav.push(CancellationRefundPage);
		}else{
			this.nav.push(page);
		}		
	}

	public login() {

		this.isActive=false;
		//WalkthroughComponent.walkthroughHasShow();
		//return false;
		if(!this.commonService.listenConnection()){
			return false;
		}

			// alert("this.commonService.listenConnection"+this.commonService.getDeviceInfo());

			this.showLoading();

			this.loading.present().then(() => {

				this.auth.login(this.registerCredentials).subscribe(allowed => {

					if(this.loading){
						this.loading.dismiss().catch(() => {});
						this.loading = null;
					}

					if (allowed) {        

        	//if logged-in user is not supper admin
        	var  userrole=(!allowed.data.isSuperAdmin || allowed.data.isSuperAdmin=="0")?'admin':'super-admin';

        	this.events.publish('user:logged-in', {role:userrole,fullName:allowed.data.fullName,subscribedPlan:allowed.data.company.subscribedPlan}, Date.now()); 
        	this.commonService.setLoggedInUserData(allowed.data);
        	this.nav.setRoot('DashboardPage',{});

        } else {
        	
        	this.showError(this.sharedClass.messages.InvalidLogin);
        }
    },
    error => {

    	this.loading.dismiss();
    	this.showError(error);
    });
			})
		}


		showLoading() {
			this.loading = this.loadingCtrl.create({
				content: 'Please wait...',
				dismissOnPageChange: false
			});
			this.loading.present();
		}

		showError(text) {


			if(this.loading){
				this.loading.dismiss().catch(() => {});
				this.loading = null;
			}	

			let alert = this.alertCtrl.create({
				title: 'Fail',
				subTitle: text,
				buttons: ['OK']
			});
    	//alert.present(promt)
    	alert.present();
    }

    
}




// WEBPACK FOOTER //
// ./src/pages/login/login.ts